import React, { Component } from 'react';
import FormClient from '../sales/FormClient';
import FormQuote from './FormQuote';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import { initClient, initErrors, initQuote } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';


class Form extends Component {
    state = {
        sale:Object.assign({},initQuote),
        errors:Object.assign({},initErrors),
        client:Object.assign({},initClient),
        errorsClient:Object.assign({},initClient),
        view: "quote",
        numberProd:1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>
    }

    parseNumber = (value) => {
        const parsed = parseFloat(value)
        return Number.isFinite(parsed) ? parsed : 0
    }

    sanitizePositiveNumberInput = (value) => {
        if (value === "") {
            return value
        }
        const parsed = parseFloat(value)
        if (!Number.isFinite(parsed)) {
            return value
        }
        return String(Math.abs(parsed))
    }

    calculateTotals = (products = [], saleOverride = {}) => {
        const saleCtx = { ...this.state.sale, ...saleOverride }
        const aibAmount = this.parseNumber(saleCtx.aib)
        let discount = 0
        let totalHT = 0
        let totalTTCProducts = 0

        products.forEach((prod) => {
            const quantity = this.parseNumber(prod.quantity)
            const priceUReal = this.parseNumber(prod.priceUReal)
            const priceTotal = this.parseNumber(prod.priceTotal)

            if (quantity <= 0 || priceTotal <= 0) {
                return
            }

            const addDiscount = (priceUReal * quantity) - priceTotal
            if (addDiscount > 0) {
                discount += addDiscount
            }

            totalTTCProducts += priceTotal
            if (saleCtx.sale_tva) {
                totalHT += priceTotal
            } else {
                const tvaRate = this.parseNumber(prod.prod_tva_rate)
                totalHT += priceTotal / (1 + tvaRate / 100)
            }
        })

        return {
            discount,
            totalHT,
            totalTTCProducts,
            total: totalTTCProducts + aibAmount,
        }
    }

    handleSelect = (option, name) => {
        console.log("SELECT HANDLE handleSelect",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");

            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            })
        } else if(name === "shop_id"){
            console.log("change shop_id");
            const resetProducts = [
                {
                    display:{value:"", label:""},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    price:"",
                    priceUReal:"",
                    priceTotal:"",
                }
            ]
            const totals = this.calculateTotals(resetProducts)

            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option,
                    products: resetProducts,
                    ...totals,
                },
                numberProd:1
            },  () =>{
                this.createAddForm()
            })
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option
                }
            })
        }
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE handleSelectProducts",{option, index});

        let value = option.value
        const shop_id = this.state.sale.shop_id
        const max = this.findMax(value, shop_id)

        let cpProducts = this.state.sale.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max.max
        cpProducts[index].stock_id = max.stock_id
        cpProducts[index].price = max.price
        cpProducts[index].priceUReal = max.price
        cpProducts[index].priceU = max.priceU
        cpProducts[index].prod_tva_rate = max.tva || 0
        cpProducts[index].priceTotal = (max.price * (cpProducts[index].quantity || 0) )
        cpProducts[index].display = option

        const totals = this.calculateTotals(cpProducts)

        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:cpProducts,
                ...totals
            }
        }, () =>{
            this.createAddForm()
        })
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE)=> { // return available stock and it's id
        const { PRODUCTS } = this.props
        let max = 0
        let stock_id = ""
        let price = 0
        let priceU = 0
        let tva = 0

        if (!PRODUCTS) return { max, stock_id, price, priceU, tva }

        // Chercher dans le stock disponible
        if (list) {
            Object.keys(list).map((ID) => {
                if(list[ID].product_id === product_id ){
                    max = list[ID].quantity
                    stock_id = ID
                    return
                }
            })
        }

        // Prix toujours depuis le catalogue produit (même sans stock)
        const product = PRODUCTS[product_id]
        if (product) {
            tva = product.tva_rate || 0
            price = (product.prix_venteTTC || 0).toFixed(2)
            priceU = (product.prix_venteHT || 0).toFixed(2)
        }

        return {
            max,
            stock_id,
            price,
            priceU,
            tva
        }
    }

    createProductList = () => {
        console.log("DEBUG,createProductList,quote",this.state.sale)
        const { sale } = this.state;
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { AVAILABLE, PRODUCTS } = this.props
        if(PRODUCTS){
            let selectedProds = sale.products.map( prod => prod.product_id)
            Object.values(PRODUCTS).map(prod => {
                // Un produit désactivé n'est plus proposé au choix. Sa fiche
                // reste dans le store : une ligne déjà posée qui le cite
                // continue de s'afficher.
                if (prod.is_disabled) return
                let selected = selectedProds.includes(prod.id)
                list.push (
                    {value:prod.id,
                    label: `${prod.marque} - ${prod.name} — ${prod.ref}`,
                    disabled:selected
                })
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()


        console.log("[INFO],createAddForm,Form, CREATE ADD FORM INDEX ",this.state.numberProd);
        for (let i = 0; i < this.state.numberProd;i++) {

            tab.push(
                <TableRow key={i} >
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.sale.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText
                            type="number"
                            min={1}
                            max={this.state.sale.products[i].max}
                            step={10}
                            className="form-control input-sm"
                            onChange={this.handleChange}
                            value={this.state.sale.products[i].quantity}
                            name={"prod_-quantity-"+i}
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.sale.products[i].max ? "Disponible : "+ this.state.sale.products[i].max :"" }
                        />
                    </TableCell>
                    <TableCell>
                        <InputText
                            disabled
                            type="number"
                            className="form-control input-sm"
                            onChange={this.handleChange}
                            value={this.state.sale.products[i].price}
                            name={"prod_-price-"+i}
                            title="Prix"
                            error={this.state.errors.products[i].price}
                            helperText={this.state.sale.products[i].priceUReal ? "Prix Unitaire Base: "+ this.state.sale.products[i].priceUReal :"" }
                        />
                    </TableCell>
                    <TableCell className="text-center" style={{width: "100px"}}>
                        <InputText
                            disabled
                            className="form-control input-sm"
                            value={(this.state.sale.products[i].prod_tva_rate !== undefined && this.state.sale.products[i].prod_tva_rate !== null && this.state.sale.products[i].prod_tva_rate !== "") ? String(this.state.sale.products[i].prod_tva_rate) : "0"}
                            name={"prod_-tva-"+i}
                            title="TVA"
                        />
                    </TableCell>
                    <TableCell >
                        <InputText
                            type="number"
                            min={0}
                            step="0.01"
                            className="form-control input-sm"
                            onChange={this.handleChange}
                            value={this.state.sale.products[i].priceTotal }
                            name={"prod_-priceTotal-"+i}
                            placeholder="Prix Total"
                            error={this.state.errors.products[i].priceTotal}
                            helperText={(this.state.sale.products[i].priceUReal && this.state.sale.products[i].quantity) ? "Prix Total Base : "+
                            (this.state.sale.products[i].priceUReal * this.state.sale.products[i].quantity ).toFixed(2) :"" }
                        />
                    </TableCell>
                </TableRow>
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        console.log("Form Sales ,handleAddProd,")
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    price:"",
                    priceUReal:"",
                    priceTotal:"",
                    prod_tva_rate: 0,
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{
                    product_id:"",
                    quantity:"",
                    priceUReal:"",
                    priceTotal:"",

                }]
            },
            numberProd:this.state.numberProd+1,
        }, () => {
            console.log('setState a été finalisé.');
            this.createAddForm()
        });
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Sales ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Sales ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            // L'import ne passe pas par la liste de choix : sans ce refus, un
            // produit désactivé entrerait par le fichier. value[5] est la fiche
            // du store que l'import a appariée à la ligne.
            if (value[5].is_disabled){
                toast.error( "Produit '"+ value[5].name+ "' désactivé : ligne ignorée. Pour le réactiver : Produits, onglet Catalogue, bouton Ajouter")
                return
            }
            const max = this.findMax(value[5].id, shop_id)
            if (max.stock_id ===""){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            nbOfProduct++

            const price = (value[3] / value[2]).toFixed(2) || max.price
            const priceU = this.state.sale.sale_tva ? max.price : (max.price / ( 1 + max.tva / 100)).toFixed(2)

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: max.max,
                stock_id: max.stock_id,
                price: price,
                priceUReal: max.price,
                priceU: priceU,
                priceTotal: value[3],
                prod_tva_rate: max.tva || 0,
              };
            const productEntryErr = {
                product_id:"",
                quantity:"",
                priceUReal:"",
                priceTotal:"",

            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);

        })
        console.log("Form Sales ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Sales ,handleAddProdByCSV,Add product",productListLocal.length)
            const totals = this.calculateTotals(productListLocal)
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    products:[
                        ...productListLocal],
                    ...totals
                },
                errors:{
                    ...this.state.errors,
                    products:[
                        ...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }

    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.sale.products)
        let cpErrors = [].concat(this.state.errors.products)

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        const totals = this.calculateTotals(cpProducts)
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products: cpProducts,
                ...totals
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
        }, () =>{
            this.createAddForm()
        })
    }
    handleChange = (e) => {
        const field = e.target.name
        const rawValue = e.target.value
        let value = rawValue
        const regexINT = /^\d+$/;
        const regexFLOAT = /^\d+(\.\d+)?$/;
        if(field.startsWith("prod_")){
            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            if (name === "quantity" || name === "price" || name === "priceTotal") {
                value = this.sanitizePositiveNumberInput(rawValue)
            }

            let cpProducts = [].concat(this.state.sale.products)
            cpProducts[index][name] = value
            if(name === "quantity") {
                if(value ==="" || regexINT.test(value)){
                const totals = this.calculateTotals(cpProducts)
                cpProducts[index].price = (cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceUReal
                cpProducts[index].priceU = this.state.sale.sale_tva ? cpProducts[index].price : (cpProducts[index].price / ( 1 + (cpProducts[index].prod_tva_rate || 0) / 100))

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            ...totals
                        }
                    }, () =>{
                        this.createAddForm()
                    })
                }

            } else if(name === "price" || name === "priceTotal") {
                if(value ==="" || regexFLOAT.test(value)){
                const totals = this.calculateTotals(cpProducts)
                cpProducts[index].price = (cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceUReal
                cpProducts[index].priceU = this.state.sale.sale_tva ? cpProducts[index].price : (cpProducts[index].price / ( 1 + (cpProducts[index].prod_tva_rate || 0) / 100))

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            ...totals
                        }
                    }, () =>{
                        this.createAddForm()
                    })
                }

            } else {
                this.setState({
                    ...this.state,
                    sale:{
                        ...this.state.sale,
                        products:cpProducts,
                    }
                }, () =>{
                    this.createAddForm()
                })
            }

        } else {
            if (field === "aib") {
                value = this.sanitizePositiveNumberInput(rawValue)
            }
            const salePatch = {[field]: value}
            const shouldRecalculateTotal = field === "aib"
            const totals = shouldRecalculateTotal
                ? this.calculateTotals(this.state.sale.products, salePatch)
                : {}
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    ...salePatch,
                    ...totals
                }
            }, () =>{
                this.createAddForm()
            })
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["transport", "taxes", "client_ref", "sale_paygo_id", "total", "totalHT", "totalTTCProducts", "discount", "sale_credit", "sale_tva", "aib"]

        const notRequiredProdItem = ["max", "prod_tva_rate", "stock_id", "price", "priceU", "priceUReal", "display"]
        const valeursNulles = ["", 0, "0"];


        const sale = Object.assign({}, this.state.sale)
        Object.keys(sale).map( field =>{
            console.log(field);

            if( isEmpty(sale[field]) && !notRequired.includes(field) ) {// input is empty
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"

            } else if(field === "products") {
                sale.products.map((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity

                        if(notRequiredProdItem.includes(field2)){
                            errors.products[j][field2] = ""
                        } else if(valeursNulles.includes(item[field2])){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ valeur nulle" + item[field2]
                            console.log('====================================,',field2,' - ',j);
                            console.log(item[field2]);
                            console.log('====================================');
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""
            }
        })

        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);

        this.setState({
            ...this.state,
            errors : errors
        })
        if(noErrors){
            this.setState({
                view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs", "Erreur")
        }
    }

    validateClient = () => {
        let noErrors = true
        let errors = this.state.errorsClient
        const client = Object.assign({}, this.state.client )

        if(!client.client_paygo_id){

            const notRequired = ["client_address", "client_email" ,"id"]
            if(this.state.sale.client_ref || this.state.sale.cli_type === "mjb"){ // old client with no phone number
               // notRequired.push("client_tel")
            }
            if(this.state.sale.cli_type !== "mjb"){ // not mjb client so no paygoID
                notRequired.push("client_paygo_id")
            }

            Object.keys(client).map( field => {
                if( ( isEmpty(client[field]) && !notRequired.includes(field)) ) { // input is empty
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                } else {// not empty
                    errors[field]=""
                }
            })
            console.log("[INFO] NOERRORS = ",noErrors);
            console.log("[INFO] VALIDATE, ERRORS = ",errors);

            this.setState({
                ...this.state,
                errorsClient : errors
            })
        }

        if(noErrors){
            this.setState({
                view:"confirm",
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
    }

    handleSelectClient = (idClient,infoClient,option) => {
        let value = idClient
        let infos = infoClient || {}

        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                clientDisplay:option,
                client_lastname:infos.client_lastname || "",
                client_firstname:infos.client_firstname || "",
                client_address:infos.client_address || "",
                client_tel:infos.client_tel || "",
                client_email:infos.client_email || "",
                client_city:infos.client_city || "",
                client_country:infos.client_country || "",
                client_paygo_id:infos.client_paygo_id || "",
                id: value,
            },
            sale:{
                ...this.state.sale,
                sale_paygo_id: this.state.sale.cli_type === "mjb" ? value : "",
                client_ref: this.state.sale.cli_type !== "mjb" ? value : "",
            }
        })
    }
    handleSelectClientInfo = (idClient,clientInfo) =>{
        console.log("[DEBUG], handleSelectClientInfo",this.state.id ," vs ", idClient)
        if (this.state.client.id  === idClient){
            this.setState({
                ...this.state,
                client:{
                    ...this.state.client,
                    client_address:clientInfo.adress,
                    client_tel:clientInfo.phone,
                }
            })
        }

    }
    handleChangeClient =  (e) => {
        const field = e.target.name
        const value = e.target.value

        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {
        this.setState({
            sending: true,
        })
        let sale = Object.assign({}, this.state.sale)
        let client = Object.assign({}, this.state.client)

            sale.unique_id = this.state.uniqueID
            sale.id = ""
            sale.return_id = []
            sale.client = client
            sale.transport = this.parseNumber(sale.transport)
            sale.taxes = this.parseNumber(sale.taxes)
            sale.discount = this.parseNumber(sale.discount)
            sale.aib = this.parseNumber(sale.aib)
            for (let i = 0; i < sale.products.length; i++){
                sale.products[i].quantity = parseInt(sale.products[i].quantity)

                let priceTTC = parseFloat(sale.products[i].priceTotal)
                let tvaRate = sale.products[i].prod_tva_rate || 0
                let priceHT;

                if (sale.sale_tva) {
                    priceHT = priceTTC;
                    tvaRate = 0;
                } else {
                    priceHT = priceTTC / (1 + tvaRate / 100);
                }

                sale.products[i].price = priceHT
                sale.products[i].priceTTC = sale.sale_tva ? priceHT : priceTTC
                sale.products[i].priceU = parseFloat(sale.products[i].priceU)
                sale.products[i].priceUReal = parseFloat(sale.products[i].priceUReal)
                sale.products[i].prod_tva_rate = tvaRate
            }
            const recalculatedTotals = this.calculateTotals(sale.products, sale)
            sale.totalHT = recalculatedTotals.totalHT
            sale.totalTTCProducts = recalculatedTotals.totalTTCProducts
            sale.total = recalculatedTotals.total
            sale.total_price = this.parseNumber(sale.total)

            try{
                const resp = await this.props.createSale(sale)

                //success
                this.setState({
                    sending: false,
                })
                toast.info("Opération enregistrée avec succès")
                this.clearForms()
                this.props.handleClose()
            }catch(err){
                console.log("ERROR", err.message);
                this.setState({
                    sending: false,
                })
                toast.error("[ERROR]"+err.message)
            }

    }
    clearForms = () => {
        this.setState({
            numberProd:1,

            sale: Object.assign({}, initQuote),
            client: Object.assign({}, initClient),
            errors: Object.assign({}, initErrors),
            errorsClient: Object.assign({}, initClient),

        })
    }

    render() {
        const { view, sale, client } = this.state;
        console.log("[STATE] NEW SALE SALE FORM ", sale);

        const fieldList = [
            {name: "client_lastname", label: "Nom", display: client.client_lastname},
            {name: "client_firstname", label: "Prénom", display: client.client_firstname},
            {name: "client_address", label: "Adresse", display: client.client_address},
            {name: "client_city", label: "Ville", display: client.client_city},
            {name: "client_country", label: "Pays", display: client.client_country},
            {name: "client_tel", label: "Téléphone", display: client.client_tel},
            {name: "client_email", label: "Email", display: client.client_email},
            {name: "shop_id", label: "Magasin", display: sale.shop_idDisplay.label},
            {name: "comments", label: "Modalités de paiement", display: sale.comments},
            {name: "transport", label: "Coût Transport", display: sale.transport},
            {name: "taxes", label: "Autres Taxes", display: sale.taxes},
            {name: "products"},
            {name: "discount", label: "Réduction Totale", display: sale.discount},
            {name: "aib", label: "AIB/BIC prélevé sur le client en FCFA", display: sale.aib},
            {name: "total", label: "Montant Total", display: sale.total},
        ]

        return (
            <React.Fragment>
                {view === "quote" &&
                    <div>
                        <FormQuote
                            {...this.state}
                            {...this.props}
                            handleSelect={this.handleSelect}
                            createAddFormP={this.state.form}
                            handleAddProd={this.handleAddProd}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleCheck={(value, name) => {
                                const salePatch = { [name]: value }
                                const shouldRecalculateTotal = name === "sale_tva"
                                const totals = shouldRecalculateTotal
                                    ? this.calculateTotals(this.state.sale.products, salePatch)
                                    : {}
                                this.setState({
                                    ...this.state,
                                    sale: {
                                        ...this.state.sale,
                                        ...salePatch,
                                        ...totals
                                    }
                                }, () => {
                                    this.createAddForm()
                                })
                            }}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                    }
                {view === "client" &&
                    <PopUp
                        title="Formulaire Client - Devis"
                        close={() => this.setState({
                            view: "quote",
                            client:initClient,
                            client_ref: "",
                            sale_paygo_id: "",
                        })}
                        submitAction={this.validateClient}
                    >
                        <FormClient
                            {...this.state}
                            {...this.props}
                            handleSelectClient={this.handleSelectClient}
                            handleChangeClient={this.handleChangeClient}
                            handleSelectClientInfo={this.handleSelectClientInfo}
                        />

                    </PopUp>

                }
                {view === "confirm" &&
                <PopUp
                    title="Résumé"
                    close={() => this.setState({view: "client"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider"
                    disabledSubmit={this.props.STATE.sales.fetching || this.state.sending}
                >
                    <TableLayout>
                        <TableBody>
                            <ConfirmFormTemplate
                                transfer={this.state.sale}
                                client={this.state.client}
                                fieldList={fieldList}
                            />
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;
